module.exports = __webpack_public_path__ + "static/media/localParaEventosEApresentacoes.972dca90.jpg";